<template>
  <!--srcviewscompanydetailsBackgroundProfilevuehtmlStart-->

  <div id="defaultId1" class="utsAVXw">
    <!-- 左侧Company -->
    <div
      id="g9b4d5"
      :class="obj?.alterList?.length > 0 ? 'uzs5SV7' : 'uzs5SV7 uzs5SV7100'"
    >
      <div id="g28a52" class="ue66f5 detail_title_20">
        {{ $t("Profile.CompanyProfile") }}
      </div>
      <div id="g3b754" class="u45402">
        <div id="g24d02" class="unkPfIK u4TrKUw">
          <contentText
            v-if="obj?.companyName != '-'"
            id="idGMUIrf"
            class="uJQHsXz"
            :titleWidth="contentTextStyle.labelLeft.titleWidth"
            :marginRight="contentTextStyle.labelLeft.marginRight"
            fontFamily="Arial"
            :label="$t('Profile.CompanyName')"
            contentAlign="flex-start"
          >
            <div id="g808c6" class="u30501">{{ obj?.companyName }}</div>
          </contentText>
          <contentText
            v-if="obj?.companyNameNative != '-'"
            id="ca364f"
            class="uJQHsXz"
            :titleWidth="contentTextStyle.labelLeft.titleWidth"
            :marginRight="contentTextStyle.labelLeft.marginRight"
            fontFamily="Arial"
            :label="$t('Profile.NativeName')"
            contentAlign="flex-start"
          >
            <div id="cf0bcc" class="u30501">{{ obj?.companyNameNative }}</div>
          </contentText>
          <contentText
            v-if="obj?.otherName != '-'"
            id="c4d135"
            class="uJQHsXz"
            :titleWidth="contentTextStyle.labelLeft.titleWidth"
            :marginRight="contentTextStyle.labelLeft.marginRight"
            fontFamily="Arial"
            :label="$t('Profile.OtherName')"
            contentAlign="flex-start"
          >
            <div id="c15ba9" class="u30501">{{ obj?.otherName }}</div>
          </contentText>
          <contentText
            v-if="obj?.companyID != '-'"
            id="cb5947"
            class="uJQHsXz"
            :titleWidth="contentTextStyle.labelLeft.titleWidth"
            :marginRight="contentTextStyle.labelLeft.marginRight"
            fontFamily="Arial"
            :label="$t('Profile.CompanyID')"
            contentAlign="flex-start"
          >
            <div id="c445a6" class="u30501">{{ obj?.companyID }}</div>
          </contentText>
          <contentText
            v-if="obj?.vATNumber != '-'"
            id="cdd55c"
            class="uJQHsXz"
            :titleWidth="contentTextStyle.labelLeft.titleWidth"
            :marginRight="contentTextStyle.labelLeft.marginRight"
            fontFamily="Arial"
            :label="$t('Profile.VATNumber')"
            contentAlign="flex-start"
          >
            <div id="cbab2b" class="u30501">{{ obj?.vATNumber }}</div>
          </contentText>
          <contentText
            v-if="obj?.stockCode != '-'"
            id="ce6a0a"
            class="uJQHsXz"
            :titleWidth="contentTextStyle.labelLeft.titleWidth"
            :marginRight="contentTextStyle.labelLeft.marginRight"
            fontFamily="Arial"
            :label="$t('Profile.StockCode')"
            contentAlign="flex-start"
          >
            <div id="c004aa" class="u30501">{{ obj?.stockCode }}</div>
          </contentText>
          <contentText
            v-if="obj?.listed != '-'"
            id="cb1ea4"
            class="uJQHsXz"
            :titleWidth="contentTextStyle.labelLeft.titleWidth"
            :marginRight="contentTextStyle.labelLeft.marginRight"
            fontFamily="Arial"
            :label="$t('Profile.Listed')"
            contentAlign="flex-start"
          >
            <div id="cebab7" class="u30501">{{ obj?.listed }}</div>
          </contentText>

          <contentText
            v-if="obj?.registrationDate != '-'"
            id="c0b661"
            class="uJQHsXz"
            :titleWidth="contentTextStyle.labelLeft.titleWidth"
            :marginRight="contentTextStyle.labelLeft.marginRight"
            fontFamily="Arial"
            :label="$t('Profile.RegistrationDate')"
            contentAlign="flex-start"
          >
            <div id="c0afd9" class="u30501">{{ obj?.registrationDate }}</div>
          </contentText>
          <contentText
            v-if="obj?.legalForm != '-'"
            id="c43947"
            class="uJQHsXz"
            :titleWidth="contentTextStyle.labelLeft.titleWidth"
            :marginRight="contentTextStyle.labelLeft.marginRight"
            fontFamily="Arial"
            :label="$t('Profile.LegalForm')"
            contentAlign="flex-start"
          >
            <div id="c23793" class="u30501">{{ obj?.legalForm }}</div>
          </contentText>
          <contentText
            v-if="obj?.companyType != '-'"
            id="cdee4f"
            class="uJQHsXz upTxhMN"
            :titleWidth="contentTextStyle.labelLeft.titleWidth"
            :marginRight="contentTextStyle.labelLeft.marginRight"
            fontFamily="Arial"
            :label="$t('Profile.CompanyType')"
            contentAlign="flex-start"
          >
            <div id="c5ee3a" class="u30501 uKVgfIN">{{ obj?.companyType }}</div>
          </contentText>
          <contentText
            v-if="obj?.legalStatus != '-'"
            id="caa5e8"
            class="uJQHsXz"
            :titleWidth="contentTextStyle.labelLeft.titleWidth"
            :marginRight="contentTextStyle.labelLeft.marginRight"
            fontFamily="Arial"
            :label="$t('Profile.LegalStatus')"
            contentAlign="flex-start"
          >
            <div id="ce84f6" class="u30501">{{ obj?.legalStatus }}</div>
          </contentText>
          <contentText
            v-if="obj?.regCapital != '-'"
            id="ceac9f"
            class="uJQHsXz"
            :titleWidth="contentTextStyle.labelLeft.titleWidth"
            :marginRight="contentTextStyle.labelLeft.marginRight"
            fontFamily="Arial"
            :label="$t('Profile.RegisteredCapital')"
            contentAlign="flex-start"
          >
            <div id="cdf16c" class="u30501">{{ obj?.regCapital }}</div>
          </contentText>
          <contentText
            v-if="obj?.paidUpCapital != '-'"
            id="cd3ce6"
            class="uJQHsXz"
            :titleWidth="contentTextStyle.labelLeft.titleWidth"
            :marginRight="contentTextStyle.labelLeft.marginRight"
            fontFamily="Arial"
            :label="$t('Profile.PaidinCapital')"
            contentAlign="flex-start"
          >
            <div id="cd0255" class="u30501">{{ obj?.paidUpCapital }}</div>
          </contentText>
        </div>
        <div id="g5376f" class="u33a47">
          <contentText
            v-if="obj?.jurisdiction != '-'"
            id="cd4e7f"
            class="uJQHsXz"
            :titleWidth="contentTextStyle.labelRight.titleWidth"
            :marginRight="contentTextStyle.labelRight.marginRight"
            fontFamily="Arial"
            :label="$t('Profile.Jurisdiction')"
            contentAlign="flex-start"
          >
            <div id="cf9fee" class="u30501">{{ obj?.jurisdiction }}</div>
          </contentText>
          <contentText
            v-if="obj?.address != '-'"
            id="c18d61"
            class="uJQHsXz"
            :titleWidth="contentTextStyle.labelRight.titleWidth"
            :marginRight="contentTextStyle.labelRight.marginRight"
            fontFamily="Arial"
            :label="$t('Profile.RegisteredAddress')"
            contentAlign="flex-start"
          >
            <div id="c2ef1e" class="u30501">{{ obj?.address }}</div>
          </contentText>
          <contentText
            v-if="obj?.district != '-'"
            id="c29cdc"
            class="uJQHsXz"
            :titleWidth="contentTextStyle.labelRight.titleWidth"
            :marginRight="contentTextStyle.labelRight.marginRight"
            fontFamily="Arial"
            :label="$t('Profile.CountyCity')"
            contentAlign="flex-start"
          >
            <div id="c24963" class="u30501">{{ obj?.district }}</div>
          </contentText>
          <contentText
            v-if="obj?.province != '-'"
            id="c29cdc"
            class="uJQHsXz"
            :titleWidth="contentTextStyle.labelRight.titleWidth"
            :marginRight="contentTextStyle.labelRight.marginRight"
            fontFamily="Arial"
            :label="$t('Profile.ProvinceState')"
            contentAlign="flex-start"
          >
            <div id="c24963" class="u30501">{{ obj?.province }}</div>
          </contentText>
          <contentText
            v-if="obj?.country != '-'"
            id="c139d0"
            class="uJQHsXz"
            :titleWidth="contentTextStyle.labelRight.titleWidth"
            :marginRight="contentTextStyle.labelRight.marginRight"
            fontFamily="Arial"
            :label="$t('Profile.CountryRegion')"
            contentAlign="flex-start"
          >
            <div id="c4eaef" class="u30501">{{ obj?.country }}</div>
          </contentText>
          <contentText
            v-if="obj?.postCode != '-'"
            id="ca8873"
            class="uJQHsXz"
            :titleWidth="contentTextStyle.labelRight.titleWidth"
            :marginRight="contentTextStyle.labelRight.marginRight"
            fontFamily="Arial"
            :label="$t('Profile.ZipCode')"
            contentAlign="flex-start"
          >
            <div id="c984c5" class="u30501">{{ obj?.postCode }}</div>
          </contentText>
          <contentText
            v-if="obj?.operatingAddress != '-'"
            id="ce5232"
            class="uJQHsXz"
            :titleWidth="contentTextStyle.labelRight.titleWidth"
            :marginRight="contentTextStyle.labelRight.marginRight"
            fontFamily="Arial"
            :label="$t('Profile.OperatingAddress')"
            contentAlign="flex-start"
          >
            <div id="c455f8" class="u30501">{{ obj?.operatingAddress }}</div>
          </contentText>
          <contentText
            v-if="obj?.operatingProvince != '-'"
            id="c1bebc"
            class="uJQHsXz"
            :titleWidth="contentTextStyle.labelRight.titleWidth"
            :marginRight="contentTextStyle.labelRight.marginRight"
            fontFamily="Arial"
            :label="$t('Profile.ProvinceState')"
            contentAlign="flex-start"
          >
            <div id="c58a9e" class="u30501">{{ obj?.operatingProvince }}</div>
          </contentText>
          <contentText
            v-if="obj?.operatingCountry != '-'"
            id="c6d1a0"
            class="uJQHsXz"
            :titleWidth="contentTextStyle.labelRight.titleWidth"
            :marginRight="contentTextStyle.labelRight.marginRight"
            fontFamily="Arial"
            :label="$t('Profile.CountryRegion')"
            contentAlign="flex-start"
          >
            <div id="c91807" class="u30501">{{ obj?.operatingCountry }}</div>
          </contentText>
          <contentText
            v-if="obj?.operatingPostCode != '-'"
            id="c0db8a"
            class="uJQHsXz"
            :titleWidth="contentTextStyle.labelRight.titleWidth"
            :marginRight="contentTextStyle.labelRight.marginRight"
            fontFamily="Arial"
            :label="$t('Profile.ZipCode')"
            contentAlign="flex-start"
          >
            <div id="cc5a91" class="u30501">{{ obj?.operatingPostCode }}</div>
          </contentText>
          <contentText
            v-if="obj?.updateTime != '-'"
            id="c656b1"
            class="uJQHsXz"
            :titleWidth="contentTextStyle.labelRight.titleWidth"
            :marginRight="contentTextStyle.labelRight.marginRight"
            fontFamily="Arial"
            :label="$t('Profile.LastUpdate')"
            contentAlign="flex-start"
          >
            <div id="c35ab5" class="u30501">{{ obj?.updateTime }}</div>
          </contentText>
          <contentText
            v-if="obj?.dataSource?.length > 0"
            id="cd94fc"
            class="uJQHsXz"
            :titleWidth="contentTextStyle.labelRight.titleWidth"
            :marginRight="contentTextStyle.labelRight.marginRight"
            fontFamily="Arial"
            :label="$t('Profile.DataSource')"
            contentAlign="flex-start"
          >
            <div
              class="txt"
              style="
                text-decoration: underline;
                color: #1290c9;
                cursor: pointer;
              "
              v-for="(item, index) in obj?.dataSource || []"
              :key="index"
              @click="setid(item.website)"
            >
              {{ item.register }}
            </div>
          </contentText>
        </div>
      </div>
      <div id="cd6ea6" class="u45402"></div>
    </div>
    <!-- 右侧History -->
    <div id="g7b671" class="uMqaGdJ" v-if="obj?.alterList?.length > 0">
      <div id="g92544" class="u6UtUkg">
        <div id="ge6ba6" class="uf472b detail_title_20">
          {{ $t("Profile.History") }}
        </div>
      </div>
      <div id="g1d9f3" class="u13dd6">
        <timeLine
          id="gfc75b"
          v-for="(item, index) in obj.alterList"
          class="u3c331"
          :time="item.alterDate"
          :name="item.name"
          :text="item.afterContent"
          :key="index"
        >
        </timeLine>
      </div>
    </div>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
  <!--srcviewscompanydetailsBackgroundProfilevuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart
import { getCompanyProfile } from "@/api/companyApi.js";
import contentText from "../../../../components/text_content/index.vue";
import timeLine from "../../../../components/timeLine/index.vue";
import ReLogin from "../../../../components/ReLogin.vue";
//importEnd

export default {
  name: "",
  props: {
    // srcviewscompanydetailsBackgroundProfilevuePropsStart
    // srcviewscompanydetailsBackgroundProfilevuePropsEnd
  },
  // created() {
  // this.$bus.$on('authCode', (status) => {
  //         this.reLoginVis = status;
  //     });
  // },
  mounted() {
    this.getCompanyProfilelist();
    this.$emit("UpdatamarkTotalList", []);
    // defaultLoad
    // srcviewscompanydetailsBackgroundProfilevueMountedStart
    this._updateContentTextBreakpoint();
    window.addEventListener("resize", this._updateContentTextBreakpoint);
    // srcviewscompanydetailsBackgroundProfilevueMountedEnd
  },
  beforeDestroy() {
    window.removeEventListener("resize", this._updateContentTextBreakpoint);
  },

  components: {
    timeLine,
    contentText,
    ReLogin,
  },

  data() {
    return {
      reLoginVis: false,
      // insertData
      // srcviewscompanydetailsBackgroundProfilevueDataStart

      // titleStyle
      obj: {
        dataSource: [],
      },
      titleStyle: {
        width: "11.71em",
        marginRight: "2.14em",
      },
      contentTextBreakpoint: "default", // 'default' | '1440' | '1279'
      // timeLineData
      timeLineData: [
        {
          time: "02-21-1997",
          text: "The company is registered as a limited liability company with the local Administration for industry and Commerce.",
          name: "Registry",
        },
        {
          time: "05-15-1999",
          text: "Shanganxin has obtained the Shanganxin(Shanghai) CPM System Information Security Level Evaluation Report issued by the Information Security Level Protection Evaluation Center of the Ministry of Public Security to evaluate the companys Shanganxin (Shanghai)CPM System security protection level as the firstlevel.",
          name: "Capital",
        },
        {
          time: "03-01-2006",
          text: "2102339048920348549342H",
          name: "Appointment",
        },
        {
          time: "12-31-2011",
          text: "350203200471089",
          name: "Finance",
        },
        {
          time: "02-21-2020",
          text: "09-23-2008",
          name: "Address",
        },
        {
          time: "02-21-1997",
          text: "The company is registered as a limited liability company with the local Administration for industry and Commerce.",
          name: "Registry",
        },
        {
          time: "05-15-1999",
          text: "Shanganxin has obtained the Shanganxin(Shanghai) CPM System Information Security Level Evaluation Report issued by the Information Security Level Protection Evaluation Center of the Ministry of Public Security to evaluate the companys Shanganxin (Shanghai)CPM System security protection level as the firstlevel.",
          name: "Capital",
        },
        {
          time: "03-01-2006",
          text: "2102339048920348549342H",
          name: "Appointment",
        },
        {
          time: "12-31-2011",
          text: "350203200471089",
          name: "Finance",
        },
        {
          time: "02-21-2020",
          text: "09-23-2008",
          name: "Address",
        },
      ],
      // srcviewscompanydetailsBackgroundProfilevueDataEnd
    };
  },
  methods: {
    getCompanyProfilelist() {
      const id3a = this.$route.query.id3a;
      getCompanyProfile({
        id3a: id3a,
      })
        .then((res) => {
          this.obj = res.data;
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    setid(row) {
      if (row.includes("http")) {
        let routeData = row;
        window.open(routeData, "_blank");
      } else {
        let routeData = "http://" + row;
        window.open(routeData, "_blank");
      }
    },
    _updateContentTextBreakpoint() {
      const w = window.innerWidth;
      if (w <= 1439) this.contentTextBreakpoint = "1439";
      else if (w <= 1920) this.contentTextBreakpoint = "1920";
      else this.contentTextBreakpoint = "default";
    },

    // srcviewscompanydetailsBackgroundProfilevueMethodEnd
  },
  computed: {
    contentTextStyle() {
      const bp = this.contentTextBreakpoint;
      const styles = {
        default: {
          labelLeft: { titleWidth: "180px", marginRight: "30px" },
          labelRight: { titleWidth: "180px", marginRight: "30px" },
        },
        1920: {
          labelLeft: { titleWidth: "132px", marginRight: "22px" },
          labelRight: { titleWidth: "142px", marginRight: "22px" },
        },
        1439: {
          labelLeft: { titleWidth: "120px", marginRight: "20px" },
          labelRight: { titleWidth: "120px", marginRight: "20px" },
        },
      };
      return styles[bp] || styles.default;
    },
  },
};
</script>
<style scoped>
.srcviewscompanydetailsBackgroundProfilevuecssStart {
}

.utsAVXw {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}

.uzs5SV7 {
  border-radius: 10px;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 30px;
  padding-top: 30px;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  background-color: rgb(255, 255, 255);
  margin-bottom: 20px;
  width: calc(100% - 522px - 9.94px);
}

.uzs5SV7100 {
  width: 100% !important;
}

.ue66f5 {
  font-size: 26px;
  line-height: 27px;
  font-family: "Arial Bold";
  color: #1290c9;
}

.u45402 {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}

.u4TrKUw {
  width: 50%;
  margin-top: 30px;
}

.uJQHsXz {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  line-height: 30px;
  box-sizing: border-box;
  min-height: 50px;
}

.uJQHsXz /deep/ .ue234e{
  color: #666666 !important;
}

.u30501 {
  font-family: "Arial";
  font-size: 18px;
  color: #1A2332 !important;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
.txt {
  font-size: 18px;
  font-family: 'Arial';
}
.u47845 {
  font-size: 18px;
  color: rgb(18, 144, 201);
  text-decoration: underline;
}

.u33a47 {
  width: 50%;
  margin-left: 100px;
  margin-top: 30px;
}

.uMqaGdJ {
  width: 522px;
  padding-top: 30px;
  padding-bottom: 30px;
  padding-left: 30px;
  background: #ffffff;
  margin-left: 10px;
  margin-bottom: 20px;
  border-radius: 10px;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
}

.u6UtUkg {
  margin-bottom: 20px;
}

.uf472b {
  font-size: 26px;
  font-family: "Arial Bold";
  color: #1290c9;
}

.u13dd6 {
  width: auto;
  height: 835px;
  padding-left: 7px;
  padding-right: 28px;
  overflow-y: scroll;
  overflow-x: initial;
}

.u3c331 {
  box-sizing: content-box;
  overflow-y: initial;
  color: #1a2332;
}

.srcviewscompanydetailsBackgroundProfilevuecssEnd {
}

.uJQHsXz .u30501 {
  flex: 1 1 auto;
}

@media screen and (max-width: 1920px) {
  .uzs5SV7 {
    padding-left: 22px;
    padding-right: 22px;
    padding-bottom: 22px;
    padding-top: 22px;
    margin-bottom: 15px;
    width: calc(100% - 392px - 8px);
  }

  .ue66f5 {
    font-size: 20px;
    line-height: 40px;
  }

  .u4TrKUw {
    margin-top: 15px;
  }

  .uJQHsXz {
    margin-bottom: 10px;
    line-height: 20px;
    min-height: 40px;
  }

  .u30501 {
    font-size: 16px;
  }
  .txt {
    font-size: 16px;
  }
  .u47845 {
    font-size: 16px;
  }

  .u33a47 {
    margin-left: 76px;
    margin-top: 15px;
  }

  .uMqaGdJ {
    width: 392px;
    padding-top: 22px;
    padding-bottom: 22px;
    padding-left: 22px;
    margin-left: 8px;
    margin-bottom: 15px;
  }

  .u6UtUkg {
    margin-bottom: 15px;
  }

  .uf472b {
    font-size: 20px;
  }

  .u13dd6 {
    height: 626px;
    padding-left: 6px;
    padding-right: 21px;
  }
}

@media screen and (max-width: 1439px) {
  .uzs5SV7 {
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;
    padding-top: 20px;
    margin-bottom: 12px;
    width: calc(100% - 350px - 7px);
  }

  .ue66f5 {
    font-size: 18px;
    line-height: 20px;
  }

  .u4TrKUw {
    margin-top: 20px;
  }

  .uJQHsXz {
    margin-bottom: 20px;
    line-height: 20px;
    min-height: 34px;
  }

  .u30501 {
    font-size: 14px;
  }
  .txt {
    font-size: 14px;
  }
  .u47845 {
    font-size: 14px;
  }

  .u33a47 {
    margin-left: 68px;
    margin-top: 12px;
  }

  .uMqaGdJ {
    width: 350px;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
    margin-left: 7px;
    margin-bottom: 12px;
  }

  .u6UtUkg {
    margin-bottom: 12px;
  }

  .uf472b {
    font-size: 18px;
  }

  .u13dd6 {
    height: 560px;
    padding-left: 5px;
    padding-right: 19px;
  }
}
</style>
